var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FieldSwitch, FieldText, FlexBox, FormField, FormGrid, Icon, Page, } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';
import { useSetState } from 'react-use';
import { Field, SubmissionError } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { ToggleBox, ToggleBoxHead } from 'fable/toggleBox';
import { useNotifications } from 'hooks/useNotifications';
import { ChatTooltipText, EmailTooltipText, MessagingTooltipText, VoicemailTooltipText, } from './constants';
export const AgentsWorkloadForm = (props) => {
    const [state, setState] = useSetState({
        enableConversationOffer: Object.entries(props.workloadSettings.allowedOffersWhileOnCall).some(([_key, value]) => value),
        hasChanged: false,
    });
    const notify = useNotifications();
    useEffect(() => {
        props.getWorkloadSettings();
    }, []);
    const handleFormSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        const { setWorkloadSettings } = props;
        const { enableConversationOffer } = state;
        if (values) {
            const payload = {
                load_limits: {
                    chat: parseInt(values.workloadSettings.loadLimits.chat, 10),
                    email: parseInt(values.workloadSettings.loadLimits.email, 10),
                    messaging: parseInt(values.workloadSettings.loadLimits.messaging, 10),
                    voicemail: parseInt(values.workloadSettings.loadLimits.voicemail, 10),
                },
                allowed_offers_while_on_call: {
                    chat: enableConversationOffer &&
                        values.workloadSettings.allowedOffersWhileOnCall.chat,
                    email: enableConversationOffer &&
                        values.workloadSettings.allowedOffersWhileOnCall.email,
                    messaging: enableConversationOffer &&
                        values.workloadSettings.allowedOffersWhileOnCall.messaging,
                    voicemail: enableConversationOffer &&
                        values.workloadSettings.allowedOffersWhileOnCall.voicemail,
                },
            };
            analytics.settingsAgentsWorkloadsFormSubmitted({ payload });
            setWorkloadSettings(payload)
                .then((_r) => {
                setState({ hasChanged: false });
                notify({
                    title: `Workload limit updated`,
                    text: `The workload settings of the agents has been updated`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                });
            })
                .catch((_e) => {
                notify({
                    title: 'An error occurred',
                    text: `An error occurred when trying to update the workload settings of the agents`,
                    icon: 'i-exclamation',
                    className: 'danger',
                });
                throw new SubmissionError({
                    _error: 'Cannot update workload settings',
                });
            });
        }
    });
    const onSwitchChange = () => {
        setState(() => ({
            hasChanged: true,
            enableConversationOffer: !state.enableConversationOffer,
        }));
    };
    const renderFieldSwitch = (field) => {
        const input = Object.assign(Object.assign({}, field.input), { checked: field.input.value });
        return _jsx(FieldSwitch, Object.assign({}, field, { input: input }));
    };
    const { pristine, submitting, smsChannel, handleSubmit, twitterChannel } = props;
    const { hasChanged } = state;
    const channelsWithAssets = {
        email: {
            label: 'Email',
            icon: 'mail',
            tooltip: EmailTooltipText,
        },
        chat: {
            label: 'Chat',
            icon: 'chat',
            tooltip: ChatTooltipText,
        },
        voicemail: {
            label: 'Voicemail',
            icon: 'voicemail',
            tooltip: VoicemailTooltipText,
        },
        messaging: {
            label: 'Messaging',
            icon: 'messaging-settings',
            tooltip: MessagingTooltipText(smsChannel, twitterChannel),
        },
    };
    return (_jsx("form", Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: _jsx(Page.Section, Object.assign({ title: "Workload limits of agents", controls: _jsx(Button, Object.assign({ disabled: (!hasChanged && pristine) || submitting, type: "submit" }, { children: "Save" })) }, { children: _jsxs(FormGrid, { children: [Object.entries(channelsWithAssets).map(([key, { label, tooltip }]) => (_jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { label: `${label} limit`, type: "number", min: "1", max: "30", step: "1", name: `workloadSettings.loadLimits.${key}`, component: FieldText, helpIcon: {
                                title: `${label} limit`,
                                text: tooltip,
                            } }) }), key))), _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(ToggleBox, Object.assign({ title: "Enable conversations offers when on phone", isOpen: state.enableConversationOffer, headComponent: ToggleBoxHead, textProps: { variant: '3' }, input: {
                                name: 'enableConversationOffer',
                                value: 'enableConversationOffer',
                            }, onChange: onSwitchChange }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", padding: "300", gap: "300" }, { children: Object.entries(channelsWithAssets).map(([key, { label, icon }]) => (_jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center", flex: "1" }, { children: [_jsx(Icon, { name: icon, color: "primary" }), label] })), _jsx(Field, { id: key, name: `workloadSettings.allowedOffersWhileOnCall.${key}`, component: renderFieldSwitch })] }), key))) })) })) }))] }) })) })));
};
